module.exports = __webpack_public_path__ + "img/game-contract.5ec09a01.png";